module.exports = __webpack_public_path__ + "static/media/IMG_0283.7696029c.jpg";